const videoHelpers = {
    async generateThumbFromVideo(videoSrc) {
        try {
            const video = document.createElement("video");
            video.crossOrigin = "anonymous";
            video.muted = true;
            video.src = videoSrc;

            // Garante que as dimensões foram carregadas
            await new Promise((resolve, reject) => {
                video.onloadedmetadata = resolve;
                video.onerror = reject;
            });

            // Agora podemos tentar capturar 1s
            video.currentTime = 1;

            await new Promise((resolve) => {
                video.onseeked = resolve;
            });

            const canvas = document.createElement("canvas");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            return canvas.toDataURL("image/jpeg");

        } catch (e) {
            console.log("Erro ao gerar thumbnail:", e);
            return null;
        }
    },

    async generateThumbFromLocalVideo(videoUrl) {
        try {
            return new Promise((resolve, reject) => {
                const video = document.createElement("video");
                video.src = videoUrl;
                video.preload = "metadata";
                video.muted = true;
                video.style.display = "none";
                document.body.appendChild(video);

                video.onloadedmetadata = () => {
                    const seekTo = video.duration > 1 ? 1 : 0;
                    video.currentTime = seekTo;
                };

                video.onerror = (e) => {
                    reject("Erro ao carregar vídeo: " + e);
                };

                video.onseeked = () => {
                    try {
                        const canvas = document.createElement("canvas");
                        canvas.width = video.videoWidth;
                        canvas.height = video.videoHeight;

                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                        const base64 = canvas.toDataURL("image/jpeg");

                        document.body.removeChild(video);
                        resolve(base64);
                    } catch (e) {
                        console.log(e)
                    }
                };
            });
        } catch (e) {
            console.log('Error creating thumb')
            console.log(e)
        }
    }
}


export default videoHelpers